import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { logNavigation } from '../utils/firebaseUtils'

const useNavigationAnalytics = () => {
	const location = useLocation()

	useEffect(() => {
		if (!location) return
		logNavigation(location.pathname.replace('/', ''))
	}, [location])
}

export default useNavigationAnalytics
